import EstruturaPost from './Componentes/EstruturaPost';
import { store } from '../../redux/store';
import { useContext, useEffect, useState } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import iconOpti from '../../assets/Icon_OPTI.svg';
import Typography from '@componentsNew/Typography';
import AnaliseLegibilidade from './Componentes/AnaliseLegibilidade';
import ContextTela from './telaContext';
import { CarregandoDadosSistema } from '@componentsNew/CarregandoDadosSistema';
import { POST_ID } from '../../routes/Variables';
import { CustomWarning } from '@componentsNew/CustomWarning';
import { alert } from '@componentsNew/CustomWarning/types';
import { SelecioneArtigos } from './Componentes/SelecioneArtigos';
import { BotaoAnalises } from './Componentes/BotaoAnalises';
import {
  classeAgruparCards,
  classeDivPrincipal,
  classeFundoBorda,
} from './Auxiliares/axiliaresCss';
import { useSalvarArtigoOpti } from '@hooks/useSalvarArtigoMinimo';
import { useAnalisesPost } from '@hooks/Analises/useAnalisesPost';
import AnaliseSeoTextual from './Componentes/AnaliseSeoTextual';
import AnaliseSeoEstrutura from './Componentes/AnaliseSeoEstrutura';
import { EstruturaPostProvider } from './Context/EstruturaPostContext';
import { TipoAnalise, obterTiposAnalise } from './../../enums/analises'
import GuardarMetadadosRedux from '../../routes/index.logica';

function DicasOtimizacao({ layout }) {
  const { setTela, mobile, desktop, setIframeLoad, tela, telaOposta } = useContext(ContextTela);

  const {
    gerarNovaAnalise: gerarNovaAnaliseLegibilidade,
    analise: analiseLegibilidade,
    carregando: carregandoLegibilidade,
    erro: erroLegibilidade,
  } = useAnalisesPost({ tipo: TipoAnalise.LEGIBILIDADE, executarAutomaticamente: true });

  const {
    gerarNovaAnalise: gerarNovaAnaliseLegibilidadeVozPassiva,
    analise: analiseLegibilidadeVozPassiva,
    carregando: carregandoLegibilidadeVozPassiva,
    erro: erroLegibilidadeVozPassiva,
  } = useAnalisesPost({ tipo: TipoAnalise.LEGIBILIDADE_VOZ_PASSIVA, executarAutomaticamente: true });

  const {
    gerarNovaAnalise: gerarNovaAnaliseLegibilidaOrtografia,
    analise: analiseLegibilidadeOrtografia,
    carregando: carregandoLegibilidadeOrtografia,
    erro: erroLegibilidadeOrtografia,
  } = useAnalisesPost({ tipo: TipoAnalise.LEGIBILIDADE_ORTOGRAFIA, executarAutomaticamente: true });

  const {
    gerarNovaAnalise: gerarNovaAnaliseLegibilidaGramatica,
    analise: analiseLegibilidadeGramatica,
    carregando: carregandoLegibilidadeGramatica,
    erro: erroLegibilidadeGramatica,
  } = useAnalisesPost({ tipo: TipoAnalise.LEGIBILIDADE_GRAMATICA, executarAutomaticamente: true });

  const {
    gerarNovaAnalise: gerarNovaAnaliseSeoTextual,
    analise: analiseSeoTextual,
    carregando: carregandoSeoTextual,
    erro: erroSeoTextual,
  } = useAnalisesPost({ tipo: TipoAnalise.TEXTUAL, executarAutomaticamente: true });

  const {
    gerarNovaAnalise: gerarNovaAnaliseSeoNaoTextual,
    analise: analiseSeoNaoTextual,
    carregando: carregandoSeoNaoTextual,
    erro: erroSeoNaoTextual,
  } = useAnalisesPost({ tipo: TipoAnalise.NAO_TEXTUAL, executarAutomaticamente: true });

  const { carregando } = useSalvarArtigoOpti();
  const idBlog = useSelect(select => select(store).getBlogIdOpti());
  const post = useSelect(select => select('core/editor').getCurrentPost());
  const [loading, setLoading] = useState(false);
  let analises = obterTiposAnalise();

  //NAO REMOVER, ESSA FUNCAO PRECISA SER CHAMADA PARA QUE OS DADOS SEJAM CARREGADOS NO REDUX E OS CAMPOS VENHAM PREENCHIDOS NO DICAS DE OTIMIZAÇAO 
  GuardarMetadadosRedux(true); 


  useEffect(() => {
    setTela(layout);
    //TODO: Analisar necessidade destas linhas
    // return () => {
    //   localStorage.removeItem('id_usuario_wp');
    //   localStorage.removeItem('id_artigo_opti');
    // }; 
  }, [])

  const gerarAnalises = () => {
    gerarNovaAnaliseLegibilidade(),
      gerarNovaAnaliseLegibilidadeVozPassiva(),
      gerarNovaAnaliseLegibilidaOrtografia(),
      gerarNovaAnaliseLegibilidaGramatica(),
      Promise.all([
        gerarNovaAnaliseSeoTextual(),
        gerarNovaAnaliseSeoNaoTextual()
      ]);
  };

  const solicitarAnaliseTelaOposta = () => {
    analises.forEach(analise => {
      document.dispatchEvent(new CustomEvent(`analise-${telaOposta}-${analise}`, {
        detail: {
          origem: tela,
          destino: telaOposta,
          status: 'CARREGANDO'
        }
      }));
    });
  };

  const handleClick = () => {
    if (loading) {
      console.warn('Análise já está sendo gerada, aguarde a conclusão.');
      return;
    }

    setLoading(true);

    try {
      gerarAnalises();
      solicitarAnaliseTelaOposta();

    } catch (error) {
      console.error(`Erro ao gerar análises na tela ${tela}:`, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {carregando && <CarregandoDadosSistema />}
      {!idBlog && !carregando && <SelecioneArtigos />}
      {idBlog != 0 && idBlog != null && idBlog != undefined && !carregando && (
        <div className={classeDivPrincipal(desktop)}>
          {desktop && (
            <div className="self-stretch flex-col justify-start items-start gap-5 flex">
              <img src={iconOpti} className="w-[4.625em]" />
              <Typography component="texto18Cinza">
                Maximize o desempenho da sua estratégia de SEO e melhore a sua visibilidade nos
                mecanismos de busca do nosso plugin.
              </Typography>
            </div>
          )}

          <iframe
            src={`${window.location.origin}?p=${POST_ID}`}
            id="opti_preview_post"
            style={{ position: 'absolute', width: 0, height: 0, border: 0 }}
            onLoad={() => {
              setIframeLoad(false);
            }}
          ></iframe>

          <div className={classeFundoBorda(mobile)}>
            {mobile && (
              <Typography component="h3" className="mt-8">
                Resumo de avaliações
              </Typography>
            )}

            <BotaoAnalises
              acaoClick={handleClick}
              legibilidade={analiseLegibilidade}
              legibilidadeVozPassiva={analiseLegibilidadeVozPassiva}
              legibilidadeOrtografia={analiseLegibilidadeOrtografia}
              legibilidadeGramatica={analiseLegibilidadeGramatica}
              seoTextual={analiseSeoTextual}
              seoNaoTextual={analiseSeoNaoTextual}
              desabilitado={carregandoLegibilidade || carregandoLegibilidadeVozPassiva || carregandoLegibilidadeOrtografia || carregandoLegibilidadeGramatica ||
                carregandoSeoTextual || carregandoSeoNaoTextual}
            />

            {post?.status === 'auto-draft' && (
              <div className="w-full">
                <CustomWarning
                  alertType={alert.warning}
                  content={'Antes de preencher os campos abaixo, salve seu post ao menos uma vez.'}
                />
              </div>
            )}

            <div className={classeAgruparCards(mobile)}>
              <EstruturaPostProvider>
                <EstruturaPost />
              </EstruturaPostProvider>

              <AnaliseLegibilidade
                analise={analiseLegibilidade}
                carregando={carregandoLegibilidade}
                erro={erroLegibilidade}
                analisePassiva={analiseLegibilidadeVozPassiva}
                carregandoPassiva={carregandoLegibilidadeVozPassiva}
                erroPassiva={erroLegibilidadeVozPassiva}
                analiseOrtografia={analiseLegibilidadeOrtografia}
                carregandoOrtografia={carregandoLegibilidadeOrtografia}
                erroOrtografia={erroLegibilidadeOrtografia}
                analiseGramatica={analiseLegibilidadeGramatica}
                carregandoGramatica={carregandoLegibilidadeGramatica}
                erroGramatica={erroLegibilidadeGramatica}
              />
              <AnaliseSeoTextual
                analise={analiseSeoTextual}
                carregando={carregandoSeoTextual}
                erro={erroSeoTextual}
              />
              <AnaliseSeoEstrutura
                analise={analiseSeoNaoTextual}
                carregando={carregandoSeoNaoTextual}
                erro={erroSeoNaoTextual}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DicasOtimizacao;